import { ServiceError } from "services/BaseService";

export const SAVE_ERROR_FALLBACK =
    "Try again, and contact support if it keeps happening.";

const readMessage = (value: unknown): string | undefined => {
    if (!value || typeof value !== "object") return undefined;
    const record = value as Record<string, unknown>;
    const message = record.message ?? record.Message;
    return typeof message === "string" && message.trim() ? message : undefined;
};

export const getSaveErrorMessages = async (
    error: unknown,
): Promise<string[]> => {
    if (!(error instanceof ServiceError)) return [SAVE_ERROR_FALLBACK];

    let body: unknown;
    try {
        body = JSON.parse(await error.response.text());
    } catch {
        return [SAVE_ERROR_FALLBACK];
    }

    if (!body || typeof body !== "object") return [SAVE_ERROR_FALLBACK];
    const record = body as Record<string, unknown>;

    const errors = record.errors ?? record.Errors;
    if (Array.isArray(errors)) {
        const messages = errors
            .map(readMessage)
            .filter((message): message is string => !!message);
        if (messages.length) return messages;
    }

    const single = record.error ?? record.Error;
    if (typeof single === "string" && single.trim()) return [single];

    return [SAVE_ERROR_FALLBACK];
};
